export default __webpack_public_path__ + "static/media/applepay.c64e3543.webp";